import { cva } from 'class-variance-authority';

export const wrapperClasses = cva('relative inline-flex self-start', {
  variants: {
    size: {
      default: '-mt-1 lg:mt-0',
      pdp: 'lg:mt-0'
    }
  },
  defaultVariants: { size: 'default' }
});

export const containerClasses = cva(
  'inline-flex items-center gap-1 bg-[#fff] bg-opacity-[.85] [clip-path:polygon(0_0,calc(100%-1px)_0,calc(100%-14px)_100%,0_100%)] lg:[clip-path:polygon(0_0,calc(100%-1px)_0,calc(100%-17px)_100%,0_100%)]',
  {
    variants: {
      size: {
        default: 'pl-1 py-0.5 pr-3.5 lg:py-1 lg:pr-[18px]',
        pdp: 'pl-2 py-1.5 pr-4 lg:py-1.5 lg:pr-[20px]'
      }
    },
    defaultVariants: { size: 'default' }
  }
);

export const diagonalClasses = cva('absolute top-0 right-0 h-full origin-top-right bg-yellow-400', {
  variants: {
    size: {
      default: 'w-0.5 skew-x-[-35deg]',
      pdp: 'w-[2.5px] skew-x-[-28deg] lg:skew-x-[-25deg]'
    }
  },
  defaultVariants: { size: 'default' }
});

export const labelClasses = cva('inline-flex items-center gap-1 leading-[14px]', {
  variants: {
    size: {
      default: 'text-[10px] lg:text-xs',
      pdp: 'text-[14px]'
    }
  },
  defaultVariants: { size: 'default' }
});

export const tooltipClasses = 'p-3 text-sm zappos:body-s shadow-lg rounded-lg bg-default-minimal text-base';
